import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import RowDetailList from "../components/detail/RowDetailList";


interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc9: React.FC<IProps> = ({ NoticeResult }) => {
  return (
    <>
    {(NoticeResult?.nouvellesEditionsEan?.length>0 || NoticeResult?.anciennesEditionsEan?.length>0) && (
          <>
          <div className="card" style={{ textAlign: 'left' }}>
              <div className="col-sm-12 card-body pae-card-grey" >
                <b className="pae-detail-section-title mb-2">Anciennes / Nouvelles éditions</b>
              </div>
              <div className="col-sm-12 card-body">
              {NoticeResult?.nouvellesEditionsEan?.length>0 && (
                <>
                  <RowDetailList titre="Nouvelles éditions :" donnees={NoticeResult?.nouvellesEditionsEan} titreCol="8" donneeCol="8"/>
                </>
              )}
              {NoticeResult?.anciennesEditionsEan?.length>0 && (
                <RowDetailList titre="Anciennes éditions :" donnees={NoticeResult?.anciennesEditionsEan} titreCol="8" donneeCol="8"/>
              )}
              </div>
            </div> 
            <br></br>
            
          </>
        )}
    </>
  );
};

export default Bloc9;
